import React, { useState } from "react";
import { HiOfficeBuilding, HiUser } from "react-icons/hi";
import LocalizaPessoaPage from "./LocalizaPessoaPage";
import LocalizaEmpresaPage from "./LocalizaEmpresaPage";

const LocalizaPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    {
      id: "pessoa",
      title: "Pessoa",
      icon: HiUser,
      render: () => <LocalizaPessoaPage />,
    },
    {
      id: "empresa",
      title: "Empresa",
      icon: HiOfficeBuilding,
      render: () => <LocalizaEmpresaPage />,
    },
  ];

  return (
    <div className="bg-gradient-to-br from-white via-slate-50 to-white px-4 py-4 rounded-2xl shadow-lg shadow-slate-200/60 border border-slate-200/70 relative">
      <div
        className="flex items-center gap-2 overflow-x-auto pb-1.5 -mx-1 px-1"
        role="tablist"
        aria-label="Localiza"
      >
        <div className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/80 p-1 shadow-sm">
          {tabs.map((tab, idx) => {
            const Icon = tab.icon;
            const isActive = idx === activeTab;
            return (
              <button
                key={tab.id}
                id={`localiza-tab-${tab.id}`}
                type="button"
                role="tab"
                aria-selected={isActive}
                aria-controls={`localiza-panel-${tab.id}`}
                tabIndex={isActive ? 0 : -1}
                onClick={() => setActiveTab(idx)}
                className={[
                  "group inline-flex items-center gap-2 rounded-full px-3 py-2 text-[11px] sm:text-sm font-semibold whitespace-nowrap transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2",
                  isActive
                    ? "bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white shadow-lg shadow-slate-500/30 ring-2 ring-slate-900/70 scale-[1.02]"
                    : "text-slate-500 hover:text-slate-700 hover:bg-slate-50",
                ].join(" ")}
              >
                <span
                  className={[
                    "flex items-center justify-center h-6 w-6 rounded-full transition-colors",
                    isActive
                      ? "bg-white/15 text-white ring-1 ring-white/30"
                      : "bg-slate-100 text-slate-600 group-hover:bg-slate-200",
                  ].join(" ")}
                >
                  <Icon className="text-[12px] sm:text-[14px]" />
                </span>
                <span>{tab.title}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-3">
        {tabs[activeTab] && (
          <div
            id={`localiza-panel-${tabs[activeTab].id}`}
            role="tabpanel"
            aria-labelledby={`localiza-tab-${tabs[activeTab].id}`}
          >
            {tabs[activeTab].render()}
          </div>
        )}
      </div>
    </div>
  );
};

export default LocalizaPage;
